export default __webpack_public_path__ + "static/arsa-a3d54c3a3174052fa05389320565194c.webp";